import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-print-document',
  templateUrl: './print-document.component.html',
  styleUrls: ['./print-document.component.scss']
})
export class PrintDocumentComponent implements OnInit {

    public ngxExtendedPdfViewerConfig: any = {
        printResolution: 600 // Define a resolução de impressão como 300 DPI
    };

    pdf: any;

    constructor(public dialogRef: MatDialogRef<PrintDocumentComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

    }
    ngOnInit(): void {
        console.log("Imprindo...");
        this.pdf = null;
        this.pdf = this.data.pdf
    }

}
